<div>
  <div *ngIf="widgetType === 'MassMutual' || widgetType === 'MMTRAD' || widgetType === 'MMOPM'">
    <bene-list-coverpath [policyType]="policyType" [dismiss]="dismiss"></bene-list-coverpath>
  </div>
  <div *ngIf="widgetType === 'MMDirect'">
    <bene-list-mmdirect [policyType]="policyType" [dismiss]="dismiss"></bene-list-mmdirect>
  </div>
</div>
